// src/taxConstants.js

const TAX_DATA = {
  2025: {
    LIMITS: {
      SOCIAL_SECURITY_WAGE_BASE: 176100,
      SOCIAL_SECURITY_RATE: 0.062,
      MEDICARE_RATE: 0.0145,
      SELF_EMPLOYMENT_TAX_RATE: 0.153,
      SELF_EMPLOYMENT_INCOME_FACTOR: 0.9235,
      CAPITAL_LOSS_LIMIT: 3000,
      CAPITAL_LOSS_LIMIT_MFS: 1500,
      LTCG_RATE_LOW: 0.0,
      LTCG_RATE_MID: 0.15,
      LTCG_RATE_HIGH: 0.20,
      IRA_CONTRIBUTION_LIMIT: 7000,
      IRA_CATCHUP_CONTRIBUTION: 1000,
      HSA_INDIVIDUAL_LIMIT: 4300,
      HSA_FAMILY_LIMIT: 8550,
      STUDENT_LOAN_INTEREST_LIMIT: 2500,
      EDUCATOR_EXPENSE_LIMIT: 300,
      SALT_CAP: 10000,
      SALT_CAP_MFS: 5000,
      MEDICAL_EXPENSE_THRESHOLD_PERCENT: 0.075,
      
      // --- UPDATED 2025 CREDITS ---
      CTC_AMOUNT: 2200, // Increased from 2000
      ODC_AMOUNT: 500,
      ACTC_REFUNDABLE_CAP: 1700,
      ACTC_EARNED_INCOME_THRESHOLD: 2500,
      
      // --- ADOPTION CREDIT UPDATES ---
      ADOPTION_CREDIT_LIMIT: 17280,
      ADOPTION_REFUNDABLE_CAP: 5000, // New refundable portion
      ADOPTION_PHASE_OUT_START: 259190,

      // --- NEW SCHEDULE 1-A LIMITS ---
      TIPS_DEDUCTION_CAP: 25000,
      OVERTIME_DEDUCTION_CAP_SINGLE: 12500,
      OVERTIME_DEDUCTION_CAP_MFJ: 25000,
      CAR_LOAN_INTEREST_CAP: 10000,
      SENIOR_BONUS_DEDUCTION: 6000,

      DEPENDENT_CARE_LIMIT_1: 3000,
      DEPENDENT_CARE_LIMIT_2: 6000,
      DEPENDENT_STD_DED_BASE: 1350,
      DEPENDENT_EARNED_INCOME_ADD: 450,
      DEPENDENT_CARE_RATES: [
        { limit: 15000, rate: 0.35 }, { limit: 17000, rate: 0.34 }, { limit: 19000, rate: 0.33 },
        { limit: 21000, rate: 0.32 }, { limit: 23000, rate: 0.31 }, { limit: 25000, rate: 0.30 },
        { limit: 27000, rate: 0.29 }, { limit: 29000, rate: 0.28 }, { limit: 31000, rate: 0.27 },
        { limit: 33000, rate: 0.26 }, { limit: 35000, rate: 0.25 }, { limit: 37000, rate: 0.24 },
        { limit: 39000, rate: 0.23 }, { limit: 41000, rate: 0.22 }, { limit: 43000, rate: 0.21 },
        { limit: Infinity, rate: 0.20 }
      ],
      // Part II: Tips
      TIPS_CAP: 25000,
      TIPS_THRESHOLD_SINGLE: 150000,
      TIPS_THRESHOLD_MFJ: 300000,
      TIPS_PHASEOUT_STEP: 1000,
      TIPS_REDUCTION_AMOUNT: 100,

      // Part III: Overtime
      OVERTIME_CAP_SINGLE: 12500,
      OVERTIME_CAP_MFJ: 25000,
      OVERTIME_THRESHOLD_SINGLE: 150000,
      OVERTIME_THRESHOLD_MFJ: 300000,
      OVERTIME_PHASEOUT_STEP: 1000,
      OVERTIME_REDUCTION_AMOUNT: 100,

      // Part IV: Car Loan
      CAR_LOAN_CAP: 10000,
      CAR_LOAN_THRESHOLD_SINGLE: 100000,
      CAR_LOAN_THRESHOLD_MFJ: 200000,
      CAR_LOAN_PHASEOUT_STEP: 1000,
      CAR_LOAN_REDUCTION_AMOUNT: 200, // Note: This is $200, not $100

      // Part V: Senior Bonus
      SENIOR_BONUS_BASE: 6000,
      SENIOR_THRESHOLD_SINGLE: 75000,
      SENIOR_THRESHOLD_MFJ: 150000,
      SENIOR_PHASEOUT_RATE: 0.06, // 6%
    },
    Single: {
      standardDeduction: 15750, // Increased
      additionalDeductionAmount: 2000,
      brackets: [
        { rate: 0.10, upTo: 11925 }, { rate: 0.12, upTo: 48475 }, { rate: 0.22, upTo: 103350 },
        { rate: 0.24, upTo: 197300 }, { rate: 0.32, upTo: 250525 }, { rate: 0.35, upTo: 626350 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 24650 }, { rate: 0.2, upTo: 26650 }, { rate: 0.1, upTo: 41000 }]
    },
    'Married Filing Jointly': {
      standardDeduction: 31500, // Increased
      additionalDeductionAmount: 1600,
      brackets: [
        { rate: 0.10, upTo: 23850 }, { rate: 0.12, upTo: 96950 }, { rate: 0.22, upTo: 206700 },
        { rate: 0.24, upTo: 394600 }, { rate: 0.32, upTo: 501050 }, { rate: 0.35, upTo: 751600 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 49300 }, { rate: 0.2, upTo: 53300 }, { rate: 0.1, upTo: 82000 }]
    },
    'Married Filing Separately': {
      standardDeduction: 15750, // Increased
      additionalDeductionAmount: 1600,
      brackets: [
        { rate: 0.10, upTo: 11925 }, { rate: 0.12, upTo: 48475 }, { rate: 0.22, upTo: 103350 },
        { rate: 0.24, upTo: 197300 }, { rate: 0.32, upTo: 250525 }, { rate: 0.35, upTo: 375800 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 24650 }, { rate: 0.2, upTo: 26650 }, { rate: 0.1, upTo: 41000 }]
    },
    'Head of Household': {
      standardDeduction: 23625, // Increased
      additionalDeductionAmount: 2000,
      brackets: [
        { rate: 0.10, upTo: 17000 }, { rate: 0.12, upTo: 64850 }, { rate: 0.22, upTo: 103350 },
        { rate: 0.24, upTo: 197300 }, { rate: 0.32, upTo: 250500 }, { rate: 0.35, upTo: 626350 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 36975 }, { rate: 0.2, upTo: 39975 }, { rate: 0.1, upTo: 61500 }]
    },
    'Qualifying Surviving Spouse': {
      standardDeduction: 31500, // Increased
      additionalDeductionAmount: 1600,
      brackets: [
        { rate: 0.10, upTo: 23850 }, { rate: 0.12, upTo: 96950 }, { rate: 0.22, upTo: 206700 },
        { rate: 0.24, upTo: 394600 }, { rate: 0.32, upTo: 501050 }, { rate: 0.35, upTo: 751600 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 49300 }, { rate: 0.2, upTo: 53300 }, { rate: 0.1, upTo: 82000 }]
    },
    CA: {
      Single: { standardDeduction: 5540, brackets: [{ rate: 0.01, upTo: 10756 }, { rate: 0.02, upTo: 25499 }, { rate: 0.04, upTo: 40245 }, { rate: 0.06, upTo: 55866 }, { rate: 0.08, upTo: 70606 }, { rate: 0.093, upTo: 360662 }, { rate: 0.103, upTo: 432791 }, { rate: 0.113, upTo: 721321 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Jointly': { standardDeduction: 11080, brackets: [{ rate: 0.01, upTo: 21512 }, { rate: 0.02, upTo: 50998 }, { rate: 0.04, upTo: 80490 }, { rate: 0.06, upTo: 111732 }, { rate: 0.08, upTo: 141212 }, { rate: 0.093, upTo: 721324 }, { rate: 0.103, upTo: 865582 }, { rate: 0.113, upTo: 1442642 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Separately': { standardDeduction: 5540, brackets: [{ rate: 0.01, upTo: 10756 }, { rate: 0.02, upTo: 25499 }, { rate: 0.04, upTo: 40245 }, { rate: 0.06, upTo: 55866 }, { rate: 0.08, upTo: 70606 }, { rate: 0.093, upTo: 360662 }, { rate: 0.103, upTo: 432791 }, { rate: 0.113, upTo: 721321 }, { rate: 0.123, upTo: Infinity }] },
      'Head of Household': { standardDeduction: 11080, brackets: [{ rate: 0.01, upTo: 21523 }, { rate: 0.02, upTo: 50999 }, { rate: 0.04, upTo: 65743 }, { rate: 0.06, upTo: 81365 }, { rate: 0.08, upTo: 96108 }, { rate: 0.093, upTo: 490499 }, { rate: 0.103, upTo: 588600 }, { rate: 0.113, upTo: 981000 }, { rate: 0.123, upTo: Infinity }] },
      'Qualifying Surviving Spouse': { standardDeduction: 11080, brackets: [{ rate: 0.01, upTo: 21512 }, { rate: 0.02, upTo: 50998 }, { rate: 0.04, upTo: 80490 }, { rate: 0.06, upTo: 111732 }, { rate: 0.08, upTo: 141212 }, { rate: 0.093, upTo: 721324 }, { rate: 0.103, upTo: 865582 }, { rate: 0.113, upTo: 1442642 }, { rate: 0.123, upTo: Infinity }] }
    }
  },
  2024: {
    LIMITS: {
      SOCIAL_SECURITY_WAGE_BASE: 168600,
      SOCIAL_SECURITY_RATE: 0.062,
      MEDICARE_RATE: 0.0145,
      SELF_EMPLOYMENT_TAX_RATE: 0.153,
      SELF_EMPLOYMENT_INCOME_FACTOR: 0.9235,
      CAPITAL_LOSS_LIMIT: 3000,
      CAPITAL_LOSS_LIMIT_MFS: 1500,
      LTCG_RATE_LOW: 0.0,
      LTCG_RATE_MID: 0.15,
      LTCG_RATE_HIGH: 0.20,
      IRA_CONTRIBUTION_LIMIT: 7000,
      IRA_CATCHUP_CONTRIBUTION: 1000,
      HSA_INDIVIDUAL_LIMIT: 4150,
      HSA_FAMILY_LIMIT: 8300,
      STUDENT_LOAN_INTEREST_LIMIT: 2500,
      EDUCATOR_EXPENSE_LIMIT: 300,
      SALT_CAP: 10000,
      SALT_CAP_MFS: 5000,
      MEDICAL_EXPENSE_THRESHOLD_PERCENT: 0.075,
      CTC_AMOUNT: 2000,
      ODC_AMOUNT: 500,
      ACTC_REFUNDABLE_CAP: 1700,
      ACTC_EARNED_INCOME_THRESHOLD: 2500,
      ADOPTION_CREDIT_LIMIT: 16810,
      ADOPTION_PHASE_OUT_START: 252150,
      DEPENDENT_CARE_LIMIT_1: 3000,
      DEPENDENT_CARE_LIMIT_2: 6000,
      DEPENDENT_STD_DED_BASE: 1300,
      DEPENDENT_EARNED_INCOME_ADD: 450,
      DEPENDENT_CARE_RATES: [
        { limit: 15000, rate: 0.35 }, { limit: 17000, rate: 0.34 }, { limit: 19000, rate: 0.33 },
        { limit: 21000, rate: 0.32 }, { limit: 23000, rate: 0.31 }, { limit: 25000, rate: 0.30 },
        { limit: 27000, rate: 0.29 }, { limit: 29000, rate: 0.28 }, { limit: 31000, rate: 0.27 },
        { limit: 33000, rate: 0.26 }, { limit: 35000, rate: 0.25 }, { limit: 37000, rate: 0.24 },
        { limit: 39000, rate: 0.23 }, { limit: 41000, rate: 0.22 }, { limit: 43000, rate: 0.21 },
        { limit: Infinity, rate: 0.20 }
      ],
    },
    Single: {
      standardDeduction: 14600,
      additionalDeductionAmount: 1950,
      brackets: [
        { rate: 0.10, upTo: 11600 }, { rate: 0.12, upTo: 47150 }, { rate: 0.22, upTo: 100525 },
        { rate: 0.24, upTo: 191950 }, { rate: 0.32, upTo: 243725 }, { rate: 0.35, upTo: 609350 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 23000 }, { rate: 0.2, upTo: 25000 }, { rate: 0.1, upTo: 38250 }]
    },
    'Married Filing Jointly': {
      standardDeduction: 29200,
      additionalDeductionAmount: 1550,
      brackets: [
        { rate: 0.10, upTo: 23200 }, { rate: 0.12, upTo: 94300 }, { rate: 0.22, upTo: 201050 },
        { rate: 0.24, upTo: 383900 }, { rate: 0.32, upTo: 487450 }, { rate: 0.35, upTo: 731200 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 46000 }, { rate: 0.2, upTo: 50000 }, { rate: 0.1, upTo: 76500 }]
    },
    'Married Filing Separately': {
      standardDeduction: 14600,
      additionalDeductionAmount: 1550,
      brackets: [
        { rate: 0.10, upTo: 11600 }, { rate: 0.12, upTo: 47150 }, { rate: 0.22, upTo: 100525 },
        { rate: 0.24, upTo: 191950 }, { rate: 0.32, upTo: 243725 }, { rate: 0.35, upTo: 365600 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 23000 }, { rate: 0.2, upTo: 25000 }, { rate: 0.1, upTo: 38250 }]
    },
    'Head of Household': {
      standardDeduction: 21900,
      additionalDeductionAmount: 1950,
      brackets: [
        { rate: 0.10, upTo: 16550 }, { rate: 0.12, upTo: 63100 }, { rate: 0.22, upTo: 100500 },
        { rate: 0.24, upTo: 191950 }, { rate: 0.32, upTo: 243700 }, { rate: 0.35, upTo: 609350 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 34500 }, { rate: 0.2, upTo: 37500 }, { rate: 0.1, upTo: 57375 }]
    },
    'Qualifying Surviving Spouse': {
      standardDeduction: 29200,
      additionalDeductionAmount: 1550,
      brackets: [
        { rate: 0.10, upTo: 23200 }, { rate: 0.12, upTo: 94300 }, { rate: 0.22, upTo: 201050 },
        { rate: 0.24, upTo: 383900 }, { rate: 0.32, upTo: 487450 }, { rate: 0.35, upTo: 731200 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 46000 }, { rate: 0.2, upTo: 50000 }, { rate: 0.1, upTo: 76500 }]
    },
    CA: {
      Single: { standardDeduction: 5202, brackets: [{ rate: 0.01, upTo: 10099 }, { rate: 0.02, upTo: 23942 }, { rate: 0.04, upTo: 37788 }, { rate: 0.06, upTo: 52455 }, { rate: 0.08, upTo: 66295 }, { rate: 0.093, upTo: 338639 }, { rate: 0.103, upTo: 406364 }, { rate: 0.113, upTo: 677275 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Jointly': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20198 }, { rate: 0.02, upTo: 47884 }, { rate: 0.04, upTo: 75576 }, { rate: 0.06, upTo: 104910 }, { rate: 0.08, upTo: 132590 }, { rate: 0.093, upTo: 677278 }, { rate: 0.103, upTo: 812728 }, { rate: 0.113, upTo: 1354550 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Separately': { standardDeduction: 5202, brackets: [{ rate: 0.01, upTo: 10099 }, { rate: 0.02, upTo: 23942 }, { rate: 0.04, upTo: 37788 }, { rate: 0.06, upTo: 52455 }, { rate: 0.08, upTo: 66295 }, { rate: 0.093, upTo: 338639 }, { rate: 0.103, upTo: 406364 }, { rate: 0.113, upTo: 677275 }, { rate: 0.123, upTo: Infinity }] },
      'Head of Household': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20212 }, { rate: 0.02, upTo: 47887 }, { rate: 0.04, upTo: 61730 }, { rate: 0.06, upTo: 76397 }, { rate: 0.08, upTo: 90240 }, { rate: 0.093, upTo: 460547 }, { rate: 0.103, upTo: 552658 }, { rate: 0.113, upTo: 921095 }, { rate: 0.123, upTo: Infinity }] },
      'Qualifying Surviving Spouse': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20198 }, { rate: 0.02, upTo: 47884 }, { rate: 0.04, upTo: 75576 }, { rate: 0.06, upTo: 104910 }, { rate: 0.08, upTo: 132590 }, { rate: 0.093, upTo: 677278 }, { rate: 0.103, upTo: 812728 }, { rate: 0.113, upTo: 1354550 }, { rate: 0.123, upTo: Infinity }] }
    }
  },
  2023: {
    LIMITS: {
      SOCIAL_SECURITY_WAGE_BASE: 160200,
      SOCIAL_SECURITY_RATE: 0.062,
      MEDICARE_RATE: 0.0145,
      SELF_EMPLOYMENT_TAX_RATE: 0.153,
      SELF_EMPLOYMENT_INCOME_FACTOR: 0.9235,
      CAPITAL_LOSS_LIMIT: 3000,
      CAPITAL_LOSS_LIMIT_MFS: 1500,
      LTCG_RATE_LOW: 0.0,
      LTCG_RATE_MID: 0.15,
      LTCG_RATE_HIGH: 0.20,
      IRA_CONTRIBUTION_LIMIT: 6500,
      IRA_CATCHUP_CONTRIBUTION: 1000,
      HSA_INDIVIDUAL_LIMIT: 3850,
      HSA_FAMILY_LIMIT: 7750,
      STUDENT_LOAN_INTEREST_LIMIT: 2500,
      EDUCATOR_EXPENSE_LIMIT: 300,
      SALT_CAP: 10000,
      SALT_CAP_MFS: 5000,
      MEDICAL_EXPENSE_THRESHOLD_PERCENT: 0.075,
      CTC_AMOUNT: 2000,
      ODC_AMOUNT: 500,
      ACTC_REFUNDABLE_CAP: 1600,
      ACTC_EARNED_INCOME_THRESHOLD: 2500,
      ADOPTION_CREDIT_LIMIT: 15950,
      ADOPTION_PHASE_OUT_START: 239230,
      DEPENDENT_CARE_LIMIT_1: 3000,
      DEPENDENT_CARE_LIMIT_2: 6000,
      DEPENDENT_STD_DED_BASE: 1250,
      DEPENDENT_EARNED_INCOME_ADD: 400,
      DEPENDENT_CARE_RATES: [
        { limit: 15000, rate: 0.35 }, { limit: 17000, rate: 0.34 }, { limit: 19000, rate: 0.33 },
        { limit: 21000, rate: 0.32 }, { limit: 23000, rate: 0.31 }, { limit: 25000, rate: 0.30 },
        { limit: 27000, rate: 0.29 }, { limit: 29000, rate: 0.28 }, { limit: 31000, rate: 0.27 },
        { limit: 33000, rate: 0.26 }, { limit: 35000, rate: 0.25 }, { limit: 37000, rate: 0.24 },
        { limit: 39000, rate: 0.23 }, { limit: 41000, rate: 0.22 }, { limit: 43000, rate: 0.21 },
        { limit: Infinity, rate: 0.20 }
      ],
    },
    Single: {
      standardDeduction: 13850,
      additionalDeductionAmount: 1850,
      brackets: [
        { rate: 0.10, upTo: 11000 }, { rate: 0.12, upTo: 44725 }, { rate: 0.22, upTo: 95375 },
        { rate: 0.24, upTo: 182100 }, { rate: 0.32, upTo: 231250 }, { rate: 0.35, upTo: 578125 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 21750 }, { rate: 0.2, upTo: 23750 }, { rate: 0.1, upTo: 36500 }]
    },
    'Married Filing Jointly': {
      standardDeduction: 27700,
      additionalDeductionAmount: 1500,
      brackets: [
        { rate: 0.10, upTo: 22000 }, { rate: 0.12, upTo: 89450 }, { rate: 0.22, upTo: 190750 },
        { rate: 0.24, upTo: 364200 }, { rate: 0.32, upTo: 462500 }, { rate: 0.35, upTo: 693750 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 43500 }, { rate: 0.2, upTo: 47500 }, { rate: 0.1, upTo: 73000 }]
    },
    'Married Filing Separately': {
      standardDeduction: 13850,
      additionalDeductionAmount: 1500,
      brackets: [
        { rate: 0.10, upTo: 11000 }, { rate: 0.12, upTo: 44725 }, { rate: 0.22, upTo: 95375 },
        { rate: 0.24, upTo: 182100 }, { rate: 0.32, upTo: 231250 }, { rate: 0.35, upTo: 346875 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 21750 }, { rate: 0.2, upTo: 23750 }, { rate: 0.1, upTo: 36500 }]
    },
    'Head of Household': {
      standardDeduction: 20800,
      additionalDeductionAmount: 1850,
      brackets: [
        { rate: 0.10, upTo: 15700 }, { rate: 0.12, upTo: 59850 }, { rate: 0.22, upTo: 95350 },
        { rate: 0.24, upTo: 182100 }, { rate: 0.32, upTo: 231250 }, { rate: 0.35, upTo: 578100 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 32625 }, { rate: 0.2, upTo: 35625 }, { rate: 0.1, upTo: 54750 }]
    },
    'Qualifying Surviving Spouse': {
      standardDeduction: 27700,
      additionalDeductionAmount: 1500,
      brackets: [
        { rate: 0.10, upTo: 22000 }, { rate: 0.12, upTo: 89450 }, { rate: 0.22, upTo: 190750 },
        { rate: 0.24, upTo: 364200 }, { rate: 0.32, upTo: 462500 }, { rate: 0.35, upTo: 693750 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 43500 }, { rate: 0.2, upTo: 47500 }, { rate: 0.1, upTo: 73000 }]
    },
    CA: {
      Single: { standardDeduction: 5202, brackets: [{ rate: 0.01, upTo: 10099 }, { rate: 0.02, upTo: 23942 }, { rate: 0.04, upTo: 37788 }, { rate: 0.06, upTo: 52455 }, { rate: 0.08, upTo: 66295 }, { rate: 0.093, upTo: 338639 }, { rate: 0.103, upTo: 406364 }, { rate: 0.113, upTo: 677275 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Jointly': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20198 }, { rate: 0.02, upTo: 47884 }, { rate: 0.04, upTo: 75576 }, { rate: 0.06, upTo: 104910 }, { rate: 0.08, upTo: 132590 }, { rate: 0.093, upTo: 677278 }, { rate: 0.103, upTo: 812728 }, { rate: 0.113, upTo: 1354550 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Separately': { standardDeduction: 5202, brackets: [{ rate: 0.01, upTo: 10099 }, { rate: 0.02, upTo: 23942 }, { rate: 0.04, upTo: 37788 }, { rate: 0.06, upTo: 52455 }, { rate: 0.08, upTo: 66295 }, { rate: 0.093, upTo: 338639 }, { rate: 0.103, upTo: 406364 }, { rate: 0.113, upTo: 677275 }, { rate: 0.123, upTo: Infinity }] },
      'Head of Household': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20212 }, { rate: 0.02, upTo: 47887 }, { rate: 0.04, upTo: 61730 }, { rate: 0.06, upTo: 76397 }, { rate: 0.08, upTo: 90240 }, { rate: 0.093, upTo: 460547 }, { rate: 0.103, upTo: 552658 }, { rate: 0.113, upTo: 921095 }, { rate: 0.123, upTo: Infinity }] },
      'Qualifying Surviving Spouse': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20198 }, { rate: 0.02, upTo: 47884 }, { rate: 0.04, upTo: 75576 }, { rate: 0.06, upTo: 104910 }, { rate: 0.08, upTo: 132590 }, { rate: 0.093, upTo: 677278 }, { rate: 0.103, upTo: 812728 }, { rate: 0.113, upTo: 1354550 }, { rate: 0.123, upTo: Infinity }] }
    }
  },
  2022: {
    LIMITS: {
      SOCIAL_SECURITY_WAGE_BASE: 147000,
      SOCIAL_SECURITY_RATE: 0.062,
      MEDICARE_RATE: 0.0145,
      SELF_EMPLOYMENT_TAX_RATE: 0.153,
      SELF_EMPLOYMENT_INCOME_FACTOR: 0.9235,
      CAPITAL_LOSS_LIMIT: 3000,
      CAPITAL_LOSS_LIMIT_MFS: 1500,
      LTCG_RATE_LOW: 0.0,
      LTCG_RATE_MID: 0.15,
      LTCG_RATE_HIGH: 0.20,
      IRA_CONTRIBUTION_LIMIT: 6000,
      IRA_CATCHUP_CONTRIBUTION: 1000,
      HSA_INDIVIDUAL_LIMIT: 3650,
      HSA_FAMILY_LIMIT: 7300,
      STUDENT_LOAN_INTEREST_LIMIT: 2500,
      EDUCATOR_EXPENSE_LIMIT: 300,
      SALT_CAP: 10000,
      SALT_CAP_MFS: 5000,
      MEDICAL_EXPENSE_THRESHOLD_PERCENT: 0.075,
      CTC_AMOUNT: 2000,
      ODC_AMOUNT: 500,
      ACTC_REFUNDABLE_CAP: 1500,
      ACTC_EARNED_INCOME_THRESHOLD: 2500,
      ADOPTION_CREDIT_LIMIT: 14890,
      ADOPTION_PHASE_OUT_START: 223410,
      DEPENDENT_CARE_LIMIT_1: 3000,
      DEPENDENT_CARE_LIMIT_2: 6000,
      DEPENDENT_STD_DED_BASE: 1150,
      DEPENDENT_EARNED_INCOME_ADD: 400,
      DEPENDENT_CARE_RATES: [
        { limit: 15000, rate: 0.35 }, { limit: 17000, rate: 0.34 }, { limit: 19000, rate: 0.33 },
        { limit: 21000, rate: 0.32 }, { limit: 23000, rate: 0.31 }, { limit: 25000, rate: 0.30 },
        { limit: 27000, rate: 0.29 }, { limit: 29000, rate: 0.28 }, { limit: 31000, rate: 0.27 },
        { limit: 33000, rate: 0.26 }, { limit: 35000, rate: 0.25 }, { limit: 37000, rate: 0.24 },
        { limit: 39000, rate: 0.23 }, { limit: 41000, rate: 0.22 }, { limit: 43000, rate: 0.21 },
        { limit: Infinity, rate: 0.20 }
      ],
    },
    Single: {
      standardDeduction: 12950,
      additionalDeductionAmount: 1750,
      brackets: [
        { rate: 0.10, upTo: 10275 }, { rate: 0.12, upTo: 41775 }, { rate: 0.22, upTo: 89075 },
        { rate: 0.24, upTo: 170050 }, { rate: 0.32, upTo: 215950 }, { rate: 0.35, upTo: 539900 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 20500 }, { rate: 0.2, upTo: 22000 }, { rate: 0.1, upTo: 34000 }]
    },
    'Married Filing Jointly': {
      standardDeduction: 25900,
      additionalDeductionAmount: 1400,
      brackets: [
        { rate: 0.10, upTo: 20550 }, { rate: 0.12, upTo: 83550 }, { rate: 0.22, upTo: 178150 },
        { rate: 0.24, upTo: 340100 }, { rate: 0.32, upTo: 431900 }, { rate: 0.35, upTo: 647850 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 41000 }, { rate: 0.2, upTo: 44000 }, { rate: 0.1, upTo: 68000 }]
    },
    'Married Filing Separately': {
      standardDeduction: 12950,
      additionalDeductionAmount: 1400,
      brackets: [
        { rate: 0.10, upTo: 10275 }, { rate: 0.12, upTo: 41775 }, { rate: 0.22, upTo: 89075 },
        { rate: 0.24, upTo: 170050 }, { rate: 0.32, upTo: 215950 }, { rate: 0.35, upTo: 323925 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 20500 }, { rate: 0.2, upTo: 22000 }, { rate: 0.1, upTo: 34000 }]
    },
    'Head of Household': {
      standardDeduction: 19400,
      additionalDeductionAmount: 1750,
      brackets: [
        { rate: 0.10, upTo: 14650 }, { rate: 0.12, upTo: 55900 }, { rate: 0.22, upTo: 89050 },
        { rate: 0.24, upTo: 170050 }, { rate: 0.32, upTo: 215950 }, { rate: 0.35, upTo: 539900 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 30750 }, { rate: 0.2, upTo: 33000 }, { rate: 0.1, upTo: 51000 }]
    },
    'Qualifying Surviving Spouse': {
      standardDeduction: 25900,
      additionalDeductionAmount: 1400,
      brackets: [
        { rate: 0.10, upTo: 20550 }, { rate: 0.12, upTo: 83550 }, { rate: 0.22, upTo: 178150 },
        { rate: 0.24, upTo: 340100 }, { rate: 0.32, upTo: 431900 }, { rate: 0.35, upTo: 647850 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 41000 }, { rate: 0.2, upTo: 44000 }, { rate: 0.1, upTo: 68000 }]
    },
    CA: {
      Single: { standardDeduction: 5202, brackets: [{ rate: 0.01, upTo: 10099 }, { rate: 0.02, upTo: 23942 }, { rate: 0.04, upTo: 37788 }, { rate: 0.06, upTo: 52455 }, { rate: 0.08, upTo: 66295 }, { rate: 0.093, upTo: 338639 }, { rate: 0.103, upTo: 406364 }, { rate: 0.113, upTo: 677275 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Jointly': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20198 }, { rate: 0.02, upTo: 47884 }, { rate: 0.04, upTo: 75576 }, { rate: 0.06, upTo: 104910 }, { rate: 0.08, upTo: 132590 }, { rate: 0.093, upTo: 677278 }, { rate: 0.103, upTo: 812728 }, { rate: 0.113, upTo: 1354550 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Separately': { standardDeduction: 5202, brackets: [{ rate: 0.01, upTo: 10099 }, { rate: 0.02, upTo: 23942 }, { rate: 0.04, upTo: 37788 }, { rate: 0.06, upTo: 52455 }, { rate: 0.08, upTo: 66295 }, { rate: 0.093, upTo: 338639 }, { rate: 0.103, upTo: 406364 }, { rate: 0.113, upTo: 677275 }, { rate: 0.123, upTo: Infinity }] },
      'Head of Household': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20212 }, { rate: 0.02, upTo: 47887 }, { rate: 0.04, upTo: 61730 }, { rate: 0.06, upTo: 76397 }, { rate: 0.08, upTo: 90240 }, { rate: 0.093, upTo: 460547 }, { rate: 0.103, upTo: 552658 }, { rate: 0.113, upTo: 921095 }, { rate: 0.123, upTo: Infinity }] },
      'Qualifying Surviving Spouse': { standardDeduction: 10404, brackets: [{ rate: 0.01, upTo: 20198 }, { rate: 0.02, upTo: 47884 }, { rate: 0.04, upTo: 75576 }, { rate: 0.06, upTo: 104910 }, { rate: 0.08, upTo: 132590 }, { rate: 0.093, upTo: 677278 }, { rate: 0.103, upTo: 812728 }, { rate: 0.113, upTo: 1354550 }, { rate: 0.123, upTo: Infinity }] }
    }
  },
  2021: {
    LIMITS: {
      SOCIAL_SECURITY_WAGE_BASE: 142800,
      SOCIAL_SECURITY_RATE: 0.062,
      MEDICARE_RATE: 0.0145,
      SELF_EMPLOYMENT_TAX_RATE: 0.153,
      SELF_EMPLOYMENT_INCOME_FACTOR: 0.9235,
      CAPITAL_LOSS_LIMIT: 3000,
      CAPITAL_LOSS_LIMIT_MFS: 1500,
      LTCG_RATE_LOW: 0.0,
      LTCG_RATE_MID: 0.15,
      LTCG_RATE_HIGH: 0.20,
      IRA_CONTRIBUTION_LIMIT: 6000,
      IRA_CATCHUP_CONTRIBUTION: 1000,
      HSA_INDIVIDUAL_LIMIT: 3600,
      HSA_FAMILY_LIMIT: 7200,
      STUDENT_LOAN_INTEREST_LIMIT: 2500,
      EDUCATOR_EXPENSE_LIMIT: 250,
      SALT_CAP: 10000,
      SALT_CAP_MFS: 5000,
      MEDICAL_EXPENSE_THRESHOLD_PERCENT: 0.075,
      CTC_AMOUNT: 3000, // Special 2021 ARPA Rule
      ODC_AMOUNT: 500,
      ACTC_REFUNDABLE_CAP: 3000, // Fully refundable in 2021
      ACTC_EARNED_INCOME_THRESHOLD: 2500,
      ADOPTION_CREDIT_LIMIT: 14440,
      ADOPTION_PHASE_OUT_START: 216660,
      DEPENDENT_CARE_LIMIT_1: 8000, // Special 2021 ARPA Rule
      DEPENDENT_CARE_LIMIT_2: 16000, // Special 2021 ARPA Rule
      DEPENDENT_STD_DED_BASE: 1100,
      DEPENDENT_EARNED_INCOME_ADD: 350,
      DEPENDENT_CARE_RATES: [
        { limit: 125000, rate: 0.50 }, // Special 2021 ARPA Rates
        { limit: 127000, rate: 0.49 }, { limit: 129000, rate: 0.48 }, { limit: 131000, rate: 0.47 },
        { limit: 133000, rate: 0.46 }, { limit: 135000, rate: 0.45 }, { limit: 137000, rate: 0.44 },
        { limit: 139000, rate: 0.43 }, { limit: 141000, rate: 0.42 }, { limit: 143000, rate: 0.41 },
        { limit: 145000, rate: 0.40 }, { limit: 147000, rate: 0.39 }, { limit: 149000, rate: 0.38 },
        { limit: 151000, rate: 0.37 }, { limit: 153000, rate: 0.36 }, { limit: 155000, rate: 0.35 },
        { limit: 157000, rate: 0.34 }, { limit: 159000, rate: 0.33 }, { limit: 161000, rate: 0.32 },
        { limit: 163000, rate: 0.31 }, { limit: 165000, rate: 0.30 }, { limit: 167000, rate: 0.29 },
        { limit: 169000, rate: 0.28 }, { limit: 171000, rate: 0.27 }, { limit: 173000, rate: 0.26 },
        { limit: 175000, rate: 0.25 }, { limit: 177000, rate: 0.24 }, { limit: 179000, rate: 0.23 },
        { limit: 181000, rate: 0.22 }, { limit: 183000, rate: 0.21 }, { limit: 400000, rate: 0.20 },
        { limit: 402000, rate: 0.19 }, { limit: 404000, rate: 0.18 }, { limit: 406000, rate: 0.17 },
        { limit: 408000, rate: 0.16 }, { limit: 410000, rate: 0.15 }, { limit: 412000, rate: 0.14 },
        { limit: 414000, rate: 0.13 }, { limit: 416000, rate: 0.12 }, { limit: 418000, rate: 0.11 },
        { limit: 420000, rate: 0.10 }, { limit: 422000, rate: 0.09 }, { limit: 424000, rate: 0.08 },
        { limit: 426000, rate: 0.07 }, { limit: 428000, rate: 0.06 }, { limit: 430000, rate: 0.05 },
        { limit: 432000, rate: 0.04 }, { limit: 434000, rate: 0.03 }, { limit: 436000, rate: 0.02 },
        { limit: 438000, rate: 0.01 }, { limit: Infinity, rate: 0.00 }
      ],
    },
    Single: {
      standardDeduction: 12550,
      additionalDeductionAmount: 1700,
      brackets: [
        { rate: 0.10, upTo: 9950 }, { rate: 0.12, upTo: 40525 }, { rate: 0.22, upTo: 86375 },
        { rate: 0.24, upTo: 164925 }, { rate: 0.32, upTo: 209425 }, { rate: 0.35, upTo: 523600 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 19750 }, { rate: 0.2, upTo: 21500 }, { rate: 0.1, upTo: 33000 }]
    },
    'Married Filing Jointly': {
      standardDeduction: 25100,
      additionalDeductionAmount: 1350,
      brackets: [
        { rate: 0.10, upTo: 19900 }, { rate: 0.12, upTo: 81050 }, { rate: 0.22, upTo: 172750 },
        { rate: 0.24, upTo: 329850 }, { rate: 0.32, upTo: 418850 }, { rate: 0.35, upTo: 628300 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 39500 }, { rate: 0.2, upTo: 43000 }, { rate: 0.1, upTo: 66000 }]
    },
    'Married Filing Separately': {
      standardDeduction: 12550,
      additionalDeductionAmount: 1350,
      brackets: [
        { rate: 0.10, upTo: 9950 }, { rate: 0.12, upTo: 40525 }, { rate: 0.22, upTo: 86375 },
        { rate: 0.24, upTo: 164925 }, { rate: 0.32, upTo: 209425 }, { rate: 0.35, upTo: 314150 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 19750 }, { rate: 0.2, upTo: 21500 }, { rate: 0.1, upTo: 33000 }]
    },
    'Head of Household': {
      standardDeduction: 18800,
      additionalDeductionAmount: 1700,
      brackets: [
        { rate: 0.10, upTo: 14200 }, { rate: 0.12, upTo: 54200 }, { rate: 0.22, upTo: 86350 },
        { rate: 0.24, upTo: 164900 }, { rate: 0.32, upTo: 209400 }, { rate: 0.35, upTo: 523600 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 29625 }, { rate: 0.2, upTo: 32250 }, { rate: 0.1, upTo: 49500 }]
    },
    'Qualifying Surviving Spouse': {
      standardDeduction: 25100,
      additionalDeductionAmount: 1350,
      brackets: [
        { rate: 0.10, upTo: 19900 }, { rate: 0.12, upTo: 81050 }, { rate: 0.22, upTo: 172750 },
        { rate: 0.24, upTo: 329850 }, { rate: 0.32, upTo: 418850 }, { rate: 0.35, upTo: 628300 },
        { rate: 0.37, upTo: Infinity },
      ],
      saversCreditThresholds: [{ rate: 0.5, upTo: 39500 }, { rate: 0.2, upTo: 43000 }, { rate: 0.1, upTo: 66000 }]
    },
    CA: {
      Single: { standardDeduction: 4803, brackets: [{ rate: 0.01, upTo: 9325 }, { rate: 0.02, upTo: 22107 }, { rate: 0.04, upTo: 34892 }, { rate: 0.06, upTo: 48435 }, { rate: 0.08, upTo: 61214 }, { rate: 0.093, upTo: 312686 }, { rate: 0.103, upTo: 375221 }, { rate: 0.113, upTo: 625369 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Jointly': { standardDeduction: 9606, brackets: [{ rate: 0.01, upTo: 18650 }, { rate: 0.02, upTo: 44214 }, { rate: 0.04, upTo: 69784 }, { rate: 0.06, upTo: 96870 }, { rate: 0.08, upTo: 122428 }, { rate: 0.093, upTo: 625372 }, { rate: 0.103, upTo: 750442 }, { rate: 0.113, upTo: 1250738 }, { rate: 0.123, upTo: Infinity }] },
      'Married Filing Separately': { standardDeduction: 4803, brackets: [{ rate: 0.01, upTo: 9325 }, { rate: 0.02, upTo: 22107 }, { rate: 0.04, upTo: 34892 }, { rate: 0.06, upTo: 48435 }, { rate: 0.08, upTo: 61214 }, { rate: 0.093, upTo: 312686 }, { rate: 0.103, upTo: 375221 }, { rate: 0.113, upTo: 625369 }, { rate: 0.123, upTo: Infinity }] },
      'Head of Household': { standardDeduction: 9606, brackets: [{ rate: 0.01, upTo: 18663 }, { rate: 0.02, upTo: 44217 }, { rate: 0.04, upTo: 56999 }, { rate: 0.06, upTo: 70537 }, { rate: 0.08, upTo: 83317 }, { rate: 0.093, upTo: 425251 }, { rate: 0.103, upTo: 510303 }, { rate: 0.113, upTo: 850499 }, { rate: 0.123, upTo: Infinity }] },
      'Qualifying Surviving Spouse': { standardDeduction: 9606, brackets: [{ rate: 0.01, upTo: 18650 }, { rate: 0.02, upTo: 44214 }, { rate: 0.04, upTo: 69784 }, { rate: 0.06, upTo: 96870 }, { rate: 0.08, upTo: 122428 }, { rate: 0.093, upTo: 625372 }, { rate: 0.103, upTo: 750442 }, { rate: 0.113, upTo: 1250738 }, { rate: 0.123, upTo: Infinity }] }
    }
  },
};

export const getTaxConstants = (year) => {
  return TAX_DATA[year] || TAX_DATA[2025];
};